// 整理桌面——主流程
const MainRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `desktop/index${i + 1}`,
  name: `desktopIndex${i + 1}`,
  component: () => import(`@/views/phoneSettings/desktop/index${i + 1}.vue`)
}))



export default {
  path: '/phoneSettings',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 整理桌面——主流程，开始
    ...MainRoutes,

  ],
};
